import React, { useEffect, useState, useRef } from 'react'
import Card from './Card'
import Map from './Map1'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import TableList from './TableListAlimentos'

const useStyles = makeStyles(theme => ({
  progress: {
    marginTop: -50,
    color: theme.palette.grey[600]
  },
  loader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 400
  },
  title: {
    fontWeight: 600,
    textAlign: 'center',
    fontSize: 23,
    margin: '3em auto 1em'
  },
  resume: {
    margin: '0 auto 3em',
    textAlign: 'center'
  }
}))

const SentenciasAlimentos = () => {
  const listContainer = useRef(null)
  const classes = useStyles()
  const [selected, setSelected] = useState([])
  const [selectedTitle, setSelectedTitle] = useState('')
  const [data, setData] = useState([])

  const [departmentsData, setDepartmentsData] = useState('')
  const scrollToRef = ref => window.scrollTo(0, ref.current.offsetTop)
  async function fetchUrl() {
    const response = await fetch(process.env.REACT_APP_API_URL + 'alimentos')
    const json = await response.json()
    const data = json.data
    setData(data)
    const departments = [...new Set(data.map(elem => elem[0]))]
    const departmentsData = departments.map(department => {
      const candidates = data.filter(f => f[0] === department)
      return { id: department, candidates, value: candidates.length }
    })
    setDepartmentsData(departmentsData)
  }

  //console.log(departmentsData)

  useEffect(() => {
    fetchUrl()
  }, [])

  const showList = id => {
    let elements = departmentsData.filter(f => f.id === id)
    if (elements.length > 0) {
      elements = elements[0]
      setSelectedTitle(
        `Candidatos de la región ${elements.name} con demandas fundadas por alimentos`
      )
      setSelected(elements.candidates)
      scrollToRef(listContainer)
    }
  }
  return (
    <div>
      {data.length > 0 ? (
        <Grid container spacing={8} justify="center">
          <Grid item md={4} xs={12}>
            {departmentsData && departmentsData.length > 0 && (
              <div style={{ margin: '2em auto' }}>
                <Map data={departmentsData} showList={showList} />
              </div>
            )}
          </Grid>
          <Grid item md={8} xs={12} ref={listContainer}>
            <h2
              style={{
                fontWeight: 300,
                textAlign: 'center',
                marginBottom: 30,
                fontSize: 18
              }}
            >
              {selectedTitle}
            </h2>
            {selected && selected.length > 0 ? (
              <div style={{ height: '100%' }}>
                <TableList data={selected} />
              </div>
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  height: '100%',
                  alignItems: 'center'
                }}
              >
                <Card />
              </div>
            )}
          </Grid>
        </Grid>
      ) : (
        <div className={classes.loader}>
          <CircularProgress className={classes.progress} />
        </div>
      )}
    </div>
  )
}

export default SentenciasAlimentos
